import { render, staticRenderFns } from "./allocateOil.vue?vue&type=template&id=0823ceb4&scoped=true"
import script from "./allocateOil.vue?vue&type=script&lang=js"
export * from "./allocateOil.vue?vue&type=script&lang=js"
import style0 from "./allocateOil.vue?vue&type=style&index=0&id=0823ceb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823ceb4",
  null
  
)

export default component.exports